// ============================================================
// main.js — Entry point
// ============================================================

// Estilos (inyectados por Webpack)
import '../scss/main.scss';

// Bootstrap 5 — bundle completo para que la data-API se auto-registre
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Módulos propios
import { initSidebar } from './sidebar.js';
import { initPromptBox, getPromptState } from './promptBox.js';
import { initGallery, createCardElement } from './gallery.js';
import { initCreationsModal } from './creationsModal.js';
import { initTemplatesPage } from './templatesPage.js';
import { initAvatarPage } from './avatarPage.js';
import { initHistorialPage } from './historialPage.js';
import { initCreacionesPage } from './creacionesPage.js';
import { initEscritorioPage } from './escritorioPage.js';
import { initGuiasPage } from './guiasPage.js';
import { initMarketingPage } from './marketingPage.js';
import { initAuthPage } from './authPage.js';
import { initPerfilPage } from './perfilPage.js';
import { initPagoPage } from './pagoPage.js';
import { initAdminPage } from './adminPage.js';
import * as api from './api.js';
import { toast } from './toast.js';

// API global para que el backend pueda interactuar desde plantillas
// (por ejemplo, inyectar datos desde el servidor con window.Vimo.setUser)
window.Vimo = {
  getPromptState,
  api,
  version: '1.0.0',
};

// Inicialización al cargar el DOM
document.addEventListener('DOMContentLoaded', () => {
  const page = document.body.dataset.page;
  const protectedPages = ['escritorio', 'imagenes', 'video', 'avatar', 'plantillas', 'historial', 'perfil', 'pago', 'creaciones', 'admin-newsletter', 'admin-suscripciones'];
  const authPages = ['login', 'registro', 'recuperar'];
  
  const token = api.getAccessToken();
  
  if (protectedPages.includes(page) && !token) {
    window.location.href = 'login.html';
    return;
  }
  
  if (authPages.includes(page) && token) {
    window.location.href = 'escritorio.html';
    return;
  }

  // Si intenta acceder a páginas de admin pero no tiene el rol admin
  const user = api.getUser();
  const adminPages = ['admin-newsletter', 'admin-suscripciones'];
  if (adminPages.includes(page) && (!user || user.role !== 'admin')) {
    window.location.href = 'escritorio.html';
    return;
  }

  // Update Topbar user info dynamically
  if (user) {
    const topName = document.querySelector('.topbar-user-name');
    const topEmail = document.querySelector('.topbar-user-email');
    const topAvatar = document.querySelector('.topbar-user-avatar');
    
    if (topName) topName.textContent = user.name || user.email.split('@')[0];
    if (topEmail) topEmail.textContent = user.email;
    if (topAvatar) {
      const initial = (user.name || user.email).substring(0, 2).toUpperCase();
      topAvatar.textContent = initial;
    }

    // Actualizar botones de la barra pública (landing / precios / inicio)
    const mkCtaGroup = document.querySelector('.mk-cta-group');
    if (mkCtaGroup) {
      mkCtaGroup.innerHTML = `
        <a href="escritorio.html" class="mk-cta-btn mk-cta-btn-outline" style="text-decoration:none;">Ir al Escritorio</a>
        <button type="button" class="mk-link-soft" id="mkAuthLogoutBtn" style="background:none;border:none;cursor:pointer;color:inherit;font-weight:600;font-size:14px;">Cerrar sesión</button>
      `;
      const logoutBtn = document.getElementById('mkAuthLogoutBtn');
      if (logoutBtn) {
        logoutBtn.addEventListener('click', () => {
          api.clearTokens();
          window.location.reload();
        });
      }
    }

    // Mostrar menús de administración si el usuario es administrador
    if (user.role === 'admin') {
      document.querySelectorAll('[data-admin-only]').forEach((el) => {
        el.style.display = '';
      });
    }
  }

  initSidebar();
  initPromptBox();
  initGallery();
  initCreationsModal();
  initTemplatesPage();
  initAvatarPage();
  initHistorialPage();
  initCreacionesPage();
  initEscritorioPage();
  initGuiasPage();
  initMarketingPage();
  initAuthPage();
  initPerfilPage();
  initPagoPage();
  initAdminPage();

  // Dropdowns Bootstrap — instanciación explícita por si la data-API
  // no se registra a tiempo (necesario en algunos bundles).
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    bootstrap.Dropdown.getOrCreateInstance(el);
  });

  // Tooltips Bootstrap
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    bootstrap.Tooltip.getOrCreateInstance(el);
  });

  // Hook global de generación — crea dinámicamente nuevas tarjetas en la rejilla
  document.addEventListener('vimo:generate', async (e) => {
    const payload = e.detail;
    console.log('[Vimo] evento vimo:generate capturado por main.js', payload);

    const gridId = payload.type === 'video' ? '#videoGallery' : '#imageGallery';
    const grid = document.querySelector(gridId);

    // Si está el mensaje de rejilla vacía, eliminarlo
    if (grid) {
      const emptyState = grid.querySelector('.gallery-empty-state');
      if (emptyState) emptyState.remove();
    }

    // Crear tarjeta de carga provisional
    const loadingCard = document.createElement('div');
    loadingCard.className = `gen-card is-generating ${payload.type === 'video' ? 'is-video' : ''}`;
    loadingCard.innerHTML = `
      <div class="gen-card-placeholder" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width:100%; height:100%; min-height: 220px;">
        <div class="spinner-border text-light" role="status" style="width: 2rem; height: 2rem; border-width: 0.2em;">
          <span class="visually-hidden">Generando...</span>
        </div>
        <span style="font-size: 0.85rem; margin-top: 10px; opacity: 0.8; font-weight: 500;">Generando...</span>
      </div>
    `;

    if (grid) {
      grid.insertBefore(loadingCard, grid.firstChild);
    }

    try {
      let result;
      if (payload.type === 'video') {
        result = await api.generateVideo(payload);
      } else {
        result = await api.generateImage(payload);
      }
      console.log('[Vimo] respuesta API:', result);

      if (result && result.result && result.result.url) {
        const url = result.result.url;
        const newCard = createCardElement({ url, title: payload.prompt }, payload.type);
        if (loadingCard.parentNode) {
          loadingCard.parentNode.replaceChild(newCard, loadingCard);
        }
      } else {
        if (loadingCard.parentNode) loadingCard.remove();
      }
    } catch (err) {
      console.error('[Vimo] error al generar:', err);
      toast({ message: `Error al generar: ${err.message}`, type: 'error' });
      if (loadingCard.parentNode) loadingCard.remove();
    }
  });
});

